import { render, staticRenderFns } from "./ethnicPri.vue?vue&type=template&id=34a3dd91&scoped=true&"
import script from "./ethnicPri.vue?vue&type=script&lang=js&"
export * from "./ethnicPri.vue?vue&type=script&lang=js&"
import style0 from "./ethnicPri.vue?vue&type=style&index=0&id=34a3dd91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a3dd91",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
